/**
 * Copyright IBM Corp. 2016, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as ResizeObserver_es from '../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js';

var require$$0 = /*@__PURE__*/getAugmentedNamespace(ResizeObserver_es);

export { require$$0 as default };
